import { Checkbox, FormControlLabel, SxProps } from "@mui/material";
import React from "react";

interface GuestOrderingProps {
  isGuestOrderingEnabled: boolean;
  onChange: (checked: boolean) => void;
  sx?: SxProps;
}

export const GuestOrdering = ({ isGuestOrderingEnabled, onChange, sx }: GuestOrderingProps) => {
  const handleCheckboxOnChange = (checked: boolean) => {
    onChange(checked);
  };

  return (
    <FormControlLabel
      label="Enable Guest Ordering"
      sx={sx}
      control={<Checkbox checked={isGuestOrderingEnabled} onChange={e => handleCheckboxOnChange(e.currentTarget.checked)} />}
    />
  );
};
